






























import { Component, Vue } from 'vue-property-decorator'

@Component({ inheritAttrs: false })
export default class PasswordField extends Vue {
  isTypePassword = true

  get type(): 'password' | 'text' {
    return this.isTypePassword ? 'password' : 'text'
  }
}
